"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetPasswordPage = ResetPasswordPage;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var react_router_dom_1 = require("react-router-dom");
var universal_cookie_1 = __importDefault(require("universal-cookie"));
var auth_1 = require("../features/apis/auth");
var auth_2 = require("../features/slices/auth");
var hooks_1 = require("../store/hooks");
function ResetPasswordPage() {
    var _this = this;
    var cookies = new universal_cookie_1.default();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var dispatch = (0, hooks_1.useAppDispatch)();
    var location = (0, react_router_dom_1.useLocation)();
    var state = location.state;
    var _a = (0, auth_1.useResetPasswordMutation)(), resetPassword = _a[0], isResetting = _a[1].isLoading;
    var _b = (0, auth_1.useLoginMutation)(), login = _b[0], isLoggingIn = _b[1].isLoading;
    var _c = (0, react_3.useState)(""), newPassword = _c[0], setNewPassword = _c[1];
    var _d = (0, react_3.useState)(""), confirmPassword = _d[0], setConfirmPassword = _d[1];
    var _e = (0, react_3.useState)(false), isNewVisible = _e[0], setIsNewVisible = _e[1];
    var _f = (0, react_3.useState)(false), isConfirmVisible = _f[0], setIsConfirmVisible = _f[1];
    var isLoading = isResetting || isLoggingIn;
    (0, react_3.useEffect)(function () {
        if (!(state === null || state === void 0 ? void 0 : state.resetToken) || !(state === null || state === void 0 ? void 0 : state.email)) {
            navigate("/login", { replace: true });
        }
    }, [state, navigate]);
    if (!(state === null || state === void 0 ? void 0 : state.resetToken) || !(state === null || state === void 0 ? void 0 : state.email)) {
        return null;
    }
    var handleResetPassword = function () { return __awaiter(_this, void 0, void 0, function () {
        var resetResponse, loginResponse, loginContent, error_1, err;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (newPassword !== confirmPassword) {
                        (0, react_1.addToast)({
                            title: "Passwords Don't Match",
                            description: "Please make sure both passwords are the same.",
                            color: "danger",
                        });
                        return [2 /*return*/];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, resetPassword({
                            resetToken: state.resetToken,
                            newPassword: newPassword,
                        }).unwrap()];
                case 2:
                    resetResponse = _b.sent();
                    if (!resetResponse.success) {
                        (0, react_1.addToast)({
                            title: "Reset Failed",
                            description: resetResponse.message || "Could not reset password. Please try again.",
                            color: "danger",
                        });
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, login({
                            email: state.email,
                            password: newPassword,
                        }).unwrap()];
                case 3:
                    loginResponse = _b.sent();
                    if (loginResponse.success && !loginResponse.content.pwdResetRequired) {
                        loginContent = loginResponse.content;
                        dispatch((0, auth_2.setCredentials)(loginContent));
                        cookies.set("user", loginContent, { path: "/", maxAge: 4 * 60 * 60 });
                        (0, react_1.addToast)({
                            title: "Password Reset Successful",
                            description: "Welcome, ".concat(loginContent.name, "! Your password has been updated."),
                            color: "success",
                        });
                        navigate("/dashboard/home", { replace: true });
                    }
                    else {
                        (0, react_1.addToast)({
                            title: "Password Reset",
                            description: "Your password has been updated. Please log in with your new password.",
                            color: "success",
                        });
                        navigate("/login", { replace: true });
                    }
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _b.sent();
                    err = error_1;
                    (0, react_1.addToast)({
                        title: "Reset Failed",
                        description: ((_a = err.data) === null || _a === void 0 ? void 0 : _a.message) || err.message || "An error occurred. Please try again.",
                        color: "danger",
                    });
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex min-h-screen items-center justify-center bg-gradient-to-br from-blue-50 to-purple-50 p-4", children: [(0, jsx_runtime_1.jsxs)(react_1.Card, { className: "w-full max-w-md shadow-xl", children: [(0, jsx_runtime_1.jsxs)(react_1.CardHeader, { className: "flex flex-col items-center gap-2 pt-8", children: [(0, jsx_runtime_1.jsx)("h1", { className: "text-3xl font-bold italic text-blue-600", children: "Let'sCue" }), (0, jsx_runtime_1.jsxs)("div", { className: "mt-4 text-center", children: [(0, jsx_runtime_1.jsx)("h2", { className: "text-2xl font-bold text-gray-900", children: "Reset Your Password" }), (0, jsx_runtime_1.jsx)("p", { className: "mt-1 text-sm text-gray-600", children: "Please choose a new password to continue" })] })] }), (0, jsx_runtime_1.jsxs)(react_1.CardBody, { className: "gap-4 px-8 pb-8", children: [(0, jsx_runtime_1.jsxs)(react_1.Form, { onSubmit: function (e) {
                                    e.preventDefault();
                                    handleResetPassword();
                                }, children: [(0, jsx_runtime_1.jsx)(react_1.Input, { type: isNewVisible ? "text" : "password", label: "New Password", placeholder: "Enter new password", validate: function (value) {
                                            if (!value)
                                                return "New password is required.";
                                            if (value.length < 6)
                                                return "Password must be at least 6 characters.";
                                        }, value: newPassword, onValueChange: setNewPassword, variant: "bordered", startContent: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:lock-password-linear", className: "text-lg text-gray-400" }), endContent: (0, jsx_runtime_1.jsx)(react_1.Button, { isIconOnly: true, variant: "light", size: "sm", onPress: function () { return setIsNewVisible(!isNewVisible); }, children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: isNewVisible ? "solar:eye-closed-linear" : "solar:eye-linear", className: "text-xl text-gray-400" }) }) }), (0, jsx_runtime_1.jsx)(react_1.Input, { type: isConfirmVisible ? "text" : "password", label: "Confirm Password", placeholder: "Confirm new password", validate: function (value) {
                                            if (!value)
                                                return "Please confirm your password.";
                                            if (value !== newPassword)
                                                return "Passwords do not match.";
                                        }, value: confirmPassword, onValueChange: setConfirmPassword, variant: "bordered", startContent: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:lock-check-linear", className: "text-lg text-gray-400" }), endContent: (0, jsx_runtime_1.jsx)(react_1.Button, { isIconOnly: true, variant: "light", size: "sm", onPress: function () { return setIsConfirmVisible(!isConfirmVisible); }, children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: isConfirmVisible ? "solar:eye-closed-linear" : "solar:eye-linear", className: "text-xl text-gray-400" }) }) }), (0, jsx_runtime_1.jsx)(react_1.Button, { color: "primary", size: "lg", className: "mt-2 w-full bg-gray-900", type: "submit", isLoading: isLoading, isDisabled: isLoading, children: isResetting ? "Resetting Password..." : isLoggingIn ? "Logging In..." : "Reset Password & Continue" })] }), (0, jsx_runtime_1.jsx)(react_1.Button, { variant: "light", className: "mt-2", onPress: function () { return navigate("/login", { replace: true }); }, children: "Back to Login" })] })] }), (0, jsx_runtime_1.jsx)("div", { className: "fixed bottom-4 right-4 text-xs text-gray-500", children: "\u00A9 Let'sCue" })] }));
}
